import type {DeadStockQuery} from '@prompt-bridge/shared/validations';

export function buildDeadStockUrl(filters: DeadStockQuery) {
  const params = new URLSearchParams({from: filters.from, to: filters.to});
  for (const id of filters.branch ?? []) {
    params.append('branch', id);
  }
  for (const id of filters.warehouse ?? []) {
    params.append('warehouse', id);
  }
  for (const id of filters.manufacturer ?? []) {
    params.append('manufacturer', id);
  }
  return `/api/v1/report/dead-stock?${params.toString()}`;
}
